var _rect, _rect2, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconboost = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 44,
  height: 44,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 44,
  fill: "#95C9B4",
  opacity: 0.3,
  rx: 22
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 36.667,
  height: 36.667,
  x: 3.667,
  y: 3.666,
  fill: "url(#icon_boost_svg__a)",
  rx: 18.333
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m17.196 17.504-1.694.13a1.51 1.51 0 0 0-1.152.679l-1.954 2.955c-.198.299-.23.673-.084 1 .145.329.443.557.797.612l1.551.24c.363-1.925 1.232-3.846 2.536-5.616M20.877 29.338l.24 1.552a1.04 1.04 0 0 0 1.036.887c.202 0 .402-.059.577-.174l2.955-1.954c.395-.26.642-.68.678-1.152l.13-1.694c-1.769 1.304-3.69 2.172-5.616 2.535M20.296 28.264a1 1 0 0 0 .162-.014 11.2 11.2 0 0 0 2.326-.66l-6.375-6.375c-.298.742-.525 1.52-.66 2.326a1 1 0 0 0 .281.87l3.558 3.558c.19.189.445.294.708.294M30.216 20.893c1.56-3.017 1.618-6.204 1.537-7.699a1.004 1.004 0 0 0-.949-.949 16 16 0 0 0-.857-.022c-1.671 0-4.316.253-6.841 1.559-2.007 1.038-4.639 3.323-6.191 6.327q.027.021.053.046l6.875 6.875a1 1 0 0 1 .046.053c3.004-1.552 5.29-4.184 6.327-6.19m-6.626-4.536a2.87 2.87 0 0 1 4.051 0c.542.54.84 1.26.84 2.025s-.299 1.485-.84 2.026a2.86 2.86 0 0 1-2.025.837c-.734 0-1.467-.279-2.026-.837a2.85 2.85 0 0 1-.839-2.026c0-.765.298-1.484.84-2.025"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M24.403 19.595a1.72 1.72 0 0 0 2.934-1.215 1.713 1.713 0 0 0-1.719-1.718A1.713 1.713 0 0 0 23.9 18.38c0 .46.178.89.503 1.215M12.809 28.337a.57.57 0 0 0 .405-.168l1.87-1.87a.573.573 0 0 0-.81-.81l-1.87 1.87a.573.573 0 0 0 .405.978M16.796 27.203a.573.573 0 0 0-.81 0l-3.597 3.596a.573.573 0 1 0 .81.81l3.597-3.596a.573.573 0 0 0 0-.81M17.697 28.916l-1.87 1.87a.573.573 0 1 0 .81.81l1.87-1.87a.573.573 0 1 0-.81-.81"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon_boost_svg__a",
  x1: 22,
  x2: 22,
  y1: 3.666,
  y2: 40.333,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00A47C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#008060"
})))));
export { SvgIconboost as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.boost.8abb7bc3.svg";